<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="9">
      <h1>Оплаты</h1>
    </v-col>
    <v-col cols="3">
      <v-text-field
          v-model="search"
          prepend-icon="mdi-magnify"
          label="Поиск"
          single-line
          otlined
          hide-details
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="12">
      <v-row>
        <v-col cols="6" class="pb-2">
          <v-btn :loading="compareLoading" @click="runCompareWithIiko">Запустить сравнение с Айко</v-btn>
        </v-col>
        <v-col cols="6" class="text-right pb-2">
          <v-btn @click="$router.push({name: 'day-stats'})">Ежедневная статистика</v-btn>
        </v-col>
        <v-col cols="12" sm="3" class="pt-2" style="min-height: 60px;">
        </v-col>
        <v-col cols="12" sm="9" class="pt-2">
          <v-slide-group class="text-right">
            <v-slide-item v-for="item in filters.onlinePayAccount.value" :key="item.id">
              <v-chip
                  class="v-btn ml-3"
                  close
                  @click:close="removeOnlinePayAccount(item)"
                  color="#FAFCFF"
                  outlined
                  label
                  text-color="currentColor"
              >
                {{ getOnlinePayAccountNameById(item) }}
              </v-chip>
            </v-slide-item>
            <v-slide-item v-if="filters.difference.value">
              <v-chip
                  class="v-btn ml-3"
                  close
                  @click:close="removeDifference()"
                  color="#FAFCFF"
                  outlined
                  label
                  text-color="currentColor"
              >
                {{ filters.difference.value == 1 ? '"Проверка" равно 0' : '"Проверка" не равно 0' }}
              </v-chip>
            </v-slide-item>
            <v-slide-item v-if="filters.created_at.valueFrom || filters.created_at.valueTo">
              <v-chip
                  class="v-btn ml-3"
                  close
                  @click:close="filters.created_at.valueFrom = null; filters.created_at.valueTo = null;"
                  color="#FAFCFF"
                  outlined
                  label
                  text-color="currentColor"
              >
                {{ filters.created_at.valueFrom }}{{
                  filters.created_at.valueFrom && filters.created_at.valueTo ? ' - ' :
                      ''
                }}{{ filters.created_at.valueTo }}
              </v-chip>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
      <v-data-table
          no-data-text="Нет записей"
          no-results-text="По заданному запросу ничего не найдено"
          v-model="selected"
          :headers="headers"
          :items="payInvoices"
          :search="search"
          :options.sync="options"
          :header-props="{sortIcon: 'icon-custom-arrow'}"
          :fixed-header="true"
          height="61vh"
          :footer-props="footerProps"
          :server-items-length="totalProducts"
          :loading="loading"
          :items-per-page="30"
          loading-text="Загрузка... Подождите пожалуйста"
      >
        <template v-slot:header.paid_at>
          Заказ поступил<br>
          <v-btn fab x-small outlined class="filter-button"
                 :class="{active: filters.created_at.valueFrom || filters.created_at.valueTo}"
                 @click.stop.prevent="filters.created_at.modal = !filters.created_at.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path
                  d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z"
                  fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:header.online_pay_account.name>
          Аккаунт онлайн оплаты<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.onlinePayAccount.value.length > 0}"
                 @click.stop.prevent="filters.onlinePayAccount.modal = !filters.onlinePayAccount.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path
                  d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z"
                  fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:header.difference>
          Проверка<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.difference.value}"
                 @click.stop.prevent="filters.difference.modal = !filters.difference.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path
                  d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z"
                  fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:body.append>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td><b>{{ totals.sum}}</b></td>
            <td><b>{{ totals.iiko_sum}}</b></td>
            <td><b>{{ totals.difference}}</b></td>
            <td></td>
          </tr>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-col>
      <div v-for="stat in statistics">
        <span><b>{{ stat.name }}:</b></span> <span>{{ stat.total_sum }} грн <span>({{ stat.orders_count }} оплат)</span></span>
      </div>
    </v-col>
    <v-dialog
        v-model="missingInvoicesModal"
        max-width="800"
    >
      <v-card>
        <v-card-title>
          Не найденные оплаты в Ликпей
        </v-card-title>
        <v-card-text>
          <v-row style="border-bottom: 1px solid #ccc">
            <v-col cols="8"><b>Iiko_id</b></v-col>
            <v-col cols="2"><b>Сумма</b></v-col>
            <v-col cols="2"><b>Заказ №</b></v-col>
          </v-row>
          <v-row v-for="invoice in missingInvoices" style="border-bottom: 1px solid #ccc" :key="invoice.iiko_id">
            <v-col cols="8">{{ invoice.iiko_id }}</v-col>
            <v-col cols="2">{{ invoice.sum }}</v-col>
            <v-col cols="2">{{ invoice.order_id }}</v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
              outlined
              @click="missingInvoicesModal = false"
          >
            Закрыть
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="filters.difference.modal"
        max-width="444"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text class="difference-variant">
          <v-radio-group v-model="filters.difference.tempValue">
            <v-radio
                label="Показать все"
                :value="null"
            ></v-radio>
            <v-radio
                label='"Проверка" равно 0'
                :value="1"
            ></v-radio>
            <v-radio
                label='"Проверка" не равно 0'
                :value="2"
            ></v-radio>
          </v-radio-group>
          <div class="text-right mt-3">

          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setDifferenceFilter">Выбрать</v-btn>
          <v-btn
              outlined
              @click="filters.difference.modal = false"
          >
            Нет
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="filters.onlinePayAccount.modal"
        max-width="444"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-select
              :items="onlinePayAccounts"
              :item-text="onlinePayAccount => onlinePayAccount.name"
              :item-value="onlinePayAccount => onlinePayAccount.id"
              v-model="filters.onlinePayAccount.tempValue"
              label="Аккаунты онлайн оплаты"
              :clearable="true"
              outlined
              multiple
              :hide-details="true"
          >
            <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="font-weight-bold">
                    Выбрано: {{ filters.onlinePayAccount.tempValue.length }}
                  </span>
            </template>
          </v-select>
          <div class="text-right mt-3">

          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setOnlinePayAccountFilter">Выбрать</v-btn>
          <v-btn
              outlined
              @click="filters.onlinePayAccount.modal = false"
          >
            Нет
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="filters.created_at.modal"
        max-width="444"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-dialog
                  ref="createdAtValueFromModal"
                  v-model="filters.created_at.valueFromModal"
                  :return-value.sync="filters.created_at.tempValueFrom"
                  width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="filters.created_at.tempValueFrom"
                      label="От"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="filters.created_at.tempValueFrom"
                    scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="filters.created_at.valueFromModal = false"
                  >
                    Отменить
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="$refs.createdAtValueFromModal.save(filters.created_at.tempValueFrom  )"
                  >
                    Выбрать
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col>
              <v-dialog
                  ref="createdAtValueToModal"
                  v-model="filters.created_at.valueToModal"
                  :return-value.sync="filters.created_at.tempValueTo"
                  width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="filters.created_at.tempValueTo"
                      label="До"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="filters.created_at.tempValueTo"
                    scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="filters.created_at.valueToModal = false"
                  >
                    Отменить
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="$refs.createdAtValueToModal.save(filters.created_at.tempValueTo  )"
                  >
                    Выбрать
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setCreatedAtFilter">Выбрать</v-btn>

          <v-btn
              outlined
              @click="filters.created_at.modal = false"
          >
            Нет
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// @ is an alias to /src

import PayInvoiceService from './../../api/PayInvoiceService'
import OnlinePayAccountService from './../../api/OnlinePayAccountService'

export default {
  name: 'PayInvoiceIndex',
  components: {},
  data: () => ({
    submitDialog: false,
    submitItem: null,
    selected: [],
    statistics: [],
    missingInvoicesModal: false,
    missingInvoices: [],
    totals: {
      iiko_sum: null,
      sum: null,
      difference: null
    },
    filters: {
      difference: {
        value: null,
        tempValue: null,
        modal: false,
      },
      onlinePayAccount: {
        value: [],
        tempValue: [],
        modal: false,
      },
      created_at: {
        valueFrom: (new Date()).toISOString().split('T')[0],
        valueFromModal: false,
        valueTo: (new Date()).toISOString().split('T')[0],
        valueToModal: false,
        tempValueFrom: '',
        tempValueTo: '',
        modal: false,
      },
    },
    overlay: false,
    search: '',
    loading: true,
    compareLoading: false,
    onlinePayAccounts: [],
    options: {},
    footerProps: {
      itemsPerPageText: 'Записей на страницу',
      pageText: '{0}-{1} из {2}',
      itemsPerPageAllText: 'Все',
      itemsPerPageOptions: [30]
    },
    totalProducts: 0,
    headers: [
      {
        text: 'Дата оплаты',
        value: 'paid_at',
        sortable: false,
      },
      {
        text: 'Pay Id',
        value: 'pay_id',
        sortable: false,
      },
      {
        text: 'Заказ №',
        value: 'order.id',
        sortable: false,
      },
      {
        text: 'Аккаунт онлайн оплаты',
        value: 'online_pay_account.name',
        sortable: false,
      },
      {
        text: 'Сумма LiqPay',
        value: 'sum',
        sortable: false,
      },
      {
        text: 'Сумма Айко',
        value: 'iiko_sum',
        sortable: true,
      },
      {
        text: 'Проверка',
        value: 'difference',
        sortable: true,
      },
      {
        text: 'Тип',
        value: 'type',
        sortable: false,
      },
    ],
    payInvoices: [],
  }),
  mounted() {
    OnlinePayAccountService.list().then(response => {
      this.onlinePayAccounts = response.data
    });
  },
  watch: {
    "filters.created_at.valueFrom": {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
    "filters.created_at.valueTo": {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
    "filters.onlinePayAccount.value": {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
    "filters.difference.value": {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
    search() {
      clearTimeout(this.timerId)
      this.timerId = setTimeout(() => {
        this.getDataFromApi()
      }, 700)
    }
  },
  methods: {
    runCompareWithIiko() {
      this.missingInvoices = []
      this.compareLoading = true
      PayInvoiceService.runCompareWithIiko().then(response => {
        this.compareLoading = false
        this.missingInvoices = response.data.res
        this.missingInvoicesModal = true
      })
    },
    setCreatedAtFilter(e) {
      this.filters.created_at.valueTo = this.filters.created_at.tempValueTo
      this.filters.created_at.valueFrom = this.filters.created_at.tempValueFrom
      this.filters.created_at.modal = false;
    },
    removeOnlinePayAccount(id) {
      this.filters.onlinePayAccount.tempValue.splice(this.filters.onlinePayAccount.tempValue.indexOf(this.filters.onlinePayAccount.tempValue.find(onlinePayAccount => onlinePayAccount.id == id)) - 1, 1);
      this.setOnlinePayAccountFilter()

    },
    removeDifference(id) {
      this.filters.difference.value = null
    },
    getOnlinePayAccountNameById(id) {
      return this.onlinePayAccounts.find(onlinePayAccount => onlinePayAccount.id == id).name;
    },
    collectSelectedId() {
      let ids = [];
      this.selected.forEach(function (item) {
        ids.push(item.id)
      })

      return ids;
    },
    setOnlinePayAccountFilter(e) {
      this.filters.onlinePayAccount.value = this.filters.onlinePayAccount.tempValue
      this.filters.onlinePayAccount.modal = false;
      this.overlay = false;
    },
    setDifferenceFilter(e) {
      this.filters.difference.value = this.filters.difference.tempValue
      this.filters.difference.modal = false;
      this.overlay = false;
    },
    productsExport() {
      PayInvoiceService.export()
          .then(response => {
            const type = response.headers['content-type']
            const blob = new Blob([response.data], {type: type, encoding: 'UTF-8'})
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'file.csv'
            link.click()
          })
    },
    getDataFromApi() {
      this.loading = true
      this.selected = [];
      let params = {
        page: this.options.page,
        sortBy: this.options.sortBy.length > 0 ? this.options.sortBy[0] : '',
        sortDesc: this.options.sortBy.length > 0 ? this.options.sortDesc[0] : '',
        paidAtFrom: this.filters.created_at.valueFrom,
        paidAtTo: this.filters.created_at.valueTo,
        search: this.search,
        onlinePayAccounts: this.filters.onlinePayAccount.value,
        differenceType: this.filters.difference.value
      }
      PayInvoiceService.list(params)
          .then(response => {
            this.payInvoices = response.data.invoices.data
            this.totalProducts = response.data.invoices.total
            this.loading = false

            this.totals.sum = response.data.total.sum
            this.totals.iiko_sum = response.data.total.iiko_sum
            this.totals.difference = response.data.total.difference

          })

      PayInvoiceService.statistics(params)
          .then(response => {
            this.statistics = response.data
          })
    },
  }
}
</script>

<style lang="scss" scoped>
.v-btn--fab.v-size--x-small {
  width: 20px;
  height: 20px;

  .mdi::before {
    font-size: 12px;
  }
}

.filter-popup {
  position: absolute;
  width: 250px;
  z-index: 5;

  &:hover {
    cursor: auto;
  }

  &.v-card--link:focus::before {
    opacity: 0;
  }
}

.difference-variant{
  &::v-deep{
    .v-input .v-label{
      transform: none!important;
    }
  }
}
</style>
